import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import Form from 'components/ui/Form';
import Col from 'components/ui/Col';
import BorderlessCard from 'components/ui/BorderlessCard';

const StyledP = styled.p`
  color: #6f6f6f;
`;

const AdditionalDetails = ({ value }) => {
  return (
    <Col span={24}>
      <Form.Item label={getTranslatedString('landlordPortal.maintenance.additionalDetails')}>
        <BorderlessCard>
          <StyledP>{value}</StyledP>
        </BorderlessCard>
      </Form.Item>
    </Col>
  );
};

export default AdditionalDetails;
